/**
 * api 都集中在这里
 * */
import {
  // sendDelete,
  sendGet,
  sendGetErr,
  sendPost,
  sendPostErr
  // sendPut,
  // sendPutErr
} from "@/utils/base";

// const prefix =
// "http://api.admin.zhiyinlou.com/server/index.php?g=Web&c=Mock&o=simple&projectID=119&uri=";
const prefix = process.env.VUE_APP_API_URL;
const cpprefix = process.env.VUE_APP_API_360URL;

// dd config
export const postDingConfig = (params: Object) =>
  sendGet(`${prefix}/api/ding/config`, params);

// js config
export const getJsConfig = (params: Object) => sendGet(`${prefix}/api/js/config`, params);

// 仿真登陆
export const postFzLogin = (params: Object) =>
  sendPost(`${prefix}/api/loginFz`, params);

// 登录 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const userLogin = (params: Object) =>
  sendPostErr(`${prefix}/api/login`, params);
//权限集合init
export const getAuthorityInit = (params: Object) =>
  sendGet(`${prefix}/api/init`, params);
// 刷新token
export const postRefresh = () => sendPost(`${prefix}/api/refresh`, {});

// week && daily yach id 换 dd id
export const exchangeId = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/user/yach`, params);

// OKR yach id 换 dd id
export const okrExchangeId = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/users/yach`, params);

// OKR AT yach id 换 dd id
export const okrAtExchangeId = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/at/yach/users`, params);

//yach id 换workcode等信息
export const exchangeYachIdToWorkcode = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/user/yach`, params);

//获取360测评
export const getCepingEntrance = () =>
  sendGet(`${cpprefix}/api/v1/project/permission/access`);
// 多企业新登录
export const postMultipleEnterPriseLogin = (params: Object) => sendPostErr(`${prefix}/api/login/code`, params);
